import React from "react";
import { motion } from "framer-motion";
import { CalendarCheck, CheckCircle2, Clock3, Sparkles } from "lucide-react";

const infoItems = [
  {
    title: "Daily sessions",
    text: "Book individual classes by location, resource, date, and time slot.",
    icon: CalendarCheck,
  },
  {
    title: "Subscriptions",
    text: "Choose a longer plan when you want consistency and better continuity.",
    icon: Clock3,
  },
  {
    title: "Simple flow",
    text: "Select your details, pay through UPI, and track status from your bookings.",
    icon: CheckCircle2,
  },
];

const HeroWithServicesInfo = ({
  eyebrow = "YogaMatic services",
  title = "Choose the yoga practice that fits your day.",
  text = "Explore personal sessions, group practice, subscriptions, and free demos led by experienced instructors.",
}) => {
  return (
    <section className="ym-hero" style={{ minHeight: 460 }}>
      <div className="ym-hero-media">
        <img src="/12535.jpg" alt="YogaMatic services" />
      </div>
      <div className="ym-hero-content" style={{ paddingTop: 70, paddingBottom: 78 }}>
        <motion.div
          className="ym-hero-panel"
          initial={{ opacity: 0, y: 26 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.55 }}
        >
          <span className="ym-eyebrow">
            <Sparkles size={14} />
            {eyebrow}
          </span>
          <h1 className="ym-title">{title}</h1>
          <p className="ym-lead">{text}</p>
        </motion.div>

        <motion.div
          className="ym-hero-highlights"
          initial="hidden"
          animate="show"
          variants={{
            hidden: {},
            show: { transition: { staggerChildren: 0.08, delayChildren: 0.18 } },
          }}
        >
          {infoItems.map((item) => {
            const Icon = item.icon;
            return (
              <motion.div
                className="ym-hero-highlight"
                key={item.title}
                variants={{ hidden: { opacity: 0, y: 16 }, show: { opacity: 1, y: 0 } }}
              >
                <Icon size={20} />
                <strong style={{ marginTop: 8 }}>{item.title}</strong>
                <span>{item.text}</span>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
};

export default HeroWithServicesInfo;
